var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillOpacity: 0,
    strokeMiterlimit: 10,
    d: "M0 256V0h256v256z",
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      mixBlendMode: "normal"
    },
    textAnchor: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      mixBlendMode: "normal"
    },
    textAnchor: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "evenodd",
    d: "M202.667 224H53.333C41.552 224 32 214.448 32 202.667V53.333C32 41.552 41.552 32 53.333 32h149.334C214.447 32 224 41.552 224 53.333v149.334c0 11.78-9.552 21.333-21.333 21.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M182.704 181.333h-34.33L73.753 74.667h34.331zm-30.24-9.045h13.67l-62.14-88.576H90.326z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "m84.619 181.333 38.416-44.501-5.024-6.661-44.288 51.162zM130.4 115.845l4.827 6.875 41.498-48.053H166.06z"
  }))));
};
export default SvgTwitter;